import { configureStore } from "@reduxjs/toolkit";

//reducers below
import userReducer from "./slices/userSlice";
import uiReducer from "./slices/uiSlice";
import categorySlice from "./slices/categorySlice";
import AttibutesSlice from "./slices/AttibutesSlice";
//reducers above

export default configureStore({
    reducer:{
        user: userReducer,
        ui: uiReducer,
        categories: categorySlice,
        Attibutes: AttibutesSlice,
    } 
})
